import http from '@/axios/http'
import { getuser_id, getuser_ctid, getuser_iscustomer } from "@/localStorage/localStorage";
//权限管理角色列表
//给出默认值，如getFunctionalAuthority为传参，offset、limit均为默认值
export function getFunctionalAuthority(offset = 1, limit = 10, language) {
    const data = {
        user_id: getuser_id(),
        offset: offset,
        limit: limit,
        language: language
    }
    return http({
        url: '/api/permission/getFunctionalAuthority',
        method: 'post',
        data
    })
}

//获取权限列表
export function showFunctionList(language, funTag) {
    const data = {
        user_id: getuser_id(),
        user_ctid: getuser_ctid(),
        user_iscustomer: getuser_iscustomer(),
        language: language,
        funTag: funTag
    }
    return http({
        url: '/api/permission/showFunctionList',
        method: 'post',
        data
    })
}

//获取角色对应权限的的复选框
export function getRoleOwnFunction(roleId, funTag) {
    const data = {
        user_id: getuser_id(),
        roleId: roleId,
        funTag: funTag
    }
    return http({
        url: '/api/permission/getRoleOwnFunction',
        method: 'post',
        data
    })
}

//修改角色权限
export function modifyRoleFunction(roleId, functionList, funTag) {
    const data = {
        roleId: roleId,
        functionList: functionList,
        user_id: getuser_id(),
        // funTag: funTag
    }
    return http({
        url: '/api/permission/modifyRoleFunction',
        method: 'post',
        data
    })
}

//删除角色

export function deleteRole(roleId) {
    const data = {
        roleId: roleId,
        user_id: getuser_id()
    }
    return http({
        url: '/api/permission/deleteRole',
        method: 'post',
        data
    })
}

//添加角色
export function addRole(role_name, role_description, functionList, funTag) {
    const data = {
        user_id: getuser_id(),
        role_name: role_name,
        role_description: role_description,
        functionList: functionList,
        funTag: funTag
    }
    return http({
        url: '/api/permission/addRole',
        method: 'post',
        data
    })
}

//修改角色
export function modifyRoleNameAndDescription(roleId, role_name, role_description) {
    const data = {
        user_id: getuser_id(),
        roleId: roleId,
        role_name: role_name,
        role_description: role_description
    }
    return http({
        url: '/api/permission/modifyRoleNameAndDescription',
        method: 'post',
        data
    })
}

//key查询角色
export function queryKeyword(offset = 1, limit = 10, keyword, sort, language) {
    const data = {
        user_id: getuser_id(),
        keyword: keyword,
        offset: offset,
        limit: limit,
        rolename: sort.rolename, //角色名称
        description: sort.description, //描述
        status: sort.status, //状态
        create: sort.create, //创建者
        cname: sort.cname, //归属客户
        craetetime: sort.craetetime, //创建时间
        language: language
    }
    return http({
        url: '/api/permission/queryKeyword',
        method: 'post',
        data
    })
}